import axios from "axios";
import { Envs } from "../conf/envs";
import { getStoredAuthToken } from "./auth-service";

const MAX_DOCUMENT_SIZE_IN_BYTES = 15 * 1024 * 1024;
const SUPPORTED_DOCUMENT_TYPES = new Set([
	"application/pdf",
	"application/msword",
	"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
]);

const isFile = (value) =>
	typeof File !== "undefined" && value instanceof File;

const getBearerToken = () => {
	const storedToken = getStoredAuthToken();
	if (!storedToken) return null;

	return storedToken.startsWith('"') ? JSON.parse(storedToken) : storedToken;
};

const uploadDocument = async (file) => {
	if (!SUPPORTED_DOCUMENT_TYPES.has(file.type.toLowerCase())) {
		throw new Error("Use documentos PDF, DOC ou DOCX.");
	}
	if (file.size > MAX_DOCUMENT_SIZE_IN_BYTES) {
		throw new Error("Cada documento pode ter, no máximo, 15 MB.");
	}

	const formData = new FormData();
	formData.append("file", file);
	const token = getBearerToken();
	const response = await axios.post(`${Envs.API_BASE}/upload/machine-document`, formData, {
		headers: token ? { Authorization: `Bearer ${token}` } : undefined,
	});

	if (!response?.data?.uri) {
		throw new Error("O servidor não devolveu o endereço do documento enviado.");
	}

	return response.data.uri;
};

export const uploadMachineDocuments = async (documents) => {
	const uploadedDocuments = [];

	for (const document of documents || []) {
		const { file, ...documentDetails } = document;
		if (!isFile(file)) {
			uploadedDocuments.push(documentDetails);
			continue;
		}

		uploadedDocuments.push({
			...documentDetails,
			data: await uploadDocument(file),
		});
	}

	return uploadedDocuments;
};
